<template>
<v-layout column>
    <v-form ref="editForm" v-model="formValid">
        <v-layout class="dialog-content" align-center justify-center>
            <v-flex xs12 md9 lg6>
                <v-layout wrap>
                    <v-flex xs9>
                        <v-autocomplete label="Variety" :items="productVarieties" item-value="ProductVarietyID" item-text="Name" v-model="selectedProductVarietyID" box clearable placeholder="Select Variety">
                        </v-autocomplete>
                    </v-flex>
                    <v-flex xs1>
                         <v-btn icon color="primary" :disabled="disableAddVariety" large @click="addVariety">
                            <v-icon large>add</v-icon>
                        </v-btn>
                    </v-flex>
                    <v-flex xs2>
                        <v-btn
                            class="ma-2"
                            color="success"
                            @click="showCheckBox()"
                            :disabled="crop.CropVarieties.length == 0"
                        >
                        {{builkEditButtonText}}
                        </v-btn>
                    </v-flex>
                    <v-flex xs2>
                        <v-btn
                            class="ma-2"
                            color="success"
                            v-if="builkEditButtonText == 'BULK UPDATE'"
                            @click="handleSelectAll()"
                            :disabled="builkEditButtonText == 'BULK EDIT'"
                        >
                        {{selectAllButtonText}}
                        </v-btn>
                    </v-flex>
                    <v-flex xs12>
                        <v-expansion-panel focusable v-model="panels">
                            <v-expansion-panel-content v-for="(item, i) in crop.CropVarieties" :key="i" style="background:rgb(235, 237, 239)">
                                <template v-slot:header>
                                    <div>
                                        <v-btn icon color="error" @click.stop="handleDeleteVariety(item)">
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                        <span>{{ lookupVarietyName(item.ProductVarietyID) }}</span>
                                    </div>
                                </template>
                                <template v-slot:actions>
                                    <v-icon color="primary">$vuetify.icons.expand</v-icon>
                                </template>
                                <v-card>
                                    <v-layout class="dialog-content" wrap>
                                        <v-flex xs12>
                                            <v-alert :value="item.ErrorMessages != null" outline type="error">
                                                <ul>
                                                    <li v-for="(error, j) in item.ErrorMessages" :key="j">
                                                        {{ error }}
                                                    </li>
                                                </ul>
                                            </v-alert>
                                        </v-flex>
                                        <v-flex xs12 pt-3 pl-3 pr-3 pb-0>
                                            <v-menu v-model="item.plantingMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field :value="formatDate(item.PlantingDate)" label="Planting Date" prepend-icon="event" readonly v-on="on" append-icon="close" :rules="[rules.required]" @click:append="clearPlantingDate(item)"></v-text-field>
                                                </template>
                                                <v-date-picker :value="formatDateYMD(item.PlantingDate)" @input="updatePlantingDate(item, $event)"></v-date-picker>
                                            </v-menu>
                                        </v-flex>            
                                    </v-layout>
                                    <crop-variety-attributes :mandatory="true" :crop="crop" :cropVariety="item" :showCheckbox="showCheckbox" :selectAll="selectAll" @add="addSelectedAttributes" @remove="removeSelectedAttributes"></crop-variety-attributes>
                                    <v-layout wrap v-if="showApplyAttributesToVarietySelector(item)">
                                        <v-flex xs12 pt-3 pl-3 pr-3 pb-0>
                                            <v-layout wrap>
                                                <v-flex xs10 pr-3>
                                                    <v-autocomplete label="Apply to other Varieties" :items="getOtherVarieties(item)" item-value="ProductVarietyID" item-text="Name" multiple v-model="selectedVarieties" box clearable placeholder="Select Varieties">
                                                    </v-autocomplete>
                                                </v-flex>
                                                <v-flex xs2>
                                                    <v-btn block color="primary" :disabled="selectedVarieties.length == 0" large @click="showConfirmApplyDialog(item)">
                                                        Apply
                                                    </v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-form>
    <v-layout row align-center justify-center>
        <v-flex xs12 md9 lg6>
            <v-layout row>
                <v-flex xs4 pa-2>
                    <v-btn color="error" block @click="$emit('cancel')">Cancel</v-btn>
                </v-flex>
                <v-flex xs4 pa-2>
                    <v-btn color="primary" block @click="$emit('previous')" :loading="submitLoading">Previous</v-btn>
                </v-flex>
                <v-flex xs4 pa-2>
                    <v-btn color="primary" :disabled="!formValid || crop.CropVarieties.length == 0" block @click="next" :loading="submitLoading">Next</v-btn>
                </v-flex>               
            </v-layout>
        </v-flex>
    </v-layout>
    <v-alert :value="submitError != null" outline type="error">
        <span>{{ submitError }}</span>
    </v-alert>
    <delete-dialog :DisplayDialog="showConfirmDelete" :DialogTitle="'Delete Item'" :DialogContents="'Are you sure you wish to delete this entry?'" @No="showConfirmDelete = false" @Yes="confirmDelete"></delete-dialog>
    <confirm-dialog :DisplayDialog="showConfirmApply" :DialogTitle="'Apply Mandatory Attributes to Varieties'" :DialogContents="'Are you sure you wish to overwrite all mandatory attributes for selected varieties?'" @No="showConfirmApply = false" @Yes="confirmApply"></confirm-dialog>
    <success-dialog :DisplayDialog="bulkEditSuccess" :DialogTitle="'Update Completed'" :DialogContents="'All selected attributes have been updated!'" @ClickedOK="hideSuccessDialog"></success-dialog>
    <v-dialog :value="showBulkEditCropVarietyAttribute" max-width="500px" persistent @keydown.esc="handleBulkEditAttributeCancel">
        <crop-variety-attribute-bulk-edit v-if="showBulkEditCropVarietyAttribute" :crop="crop" @cancel="handleBulkEditAttributeCancel" @submit="handleBulkEditAttributeSubmit">
        </crop-variety-attribute-bulk-edit>
    </v-dialog>
</v-layout>
</template>

<script>
import CropVarietyAttributes from '@/components/crops/CropVarietyAttributes.vue';
import CropVarietyAttributeBulkEdit from '@/components/crops/CropVarietyAttributeBulkEdit.vue'
import DeleteDialog from '@/components/generic/YesNoPopup.vue';
import ConfirmDialog from '@/components/generic/YesNoPopup.vue';
import SuccessDialog from '@/components/generic/OkPopup.vue';
import UtilService from '@/services/utilService.js';
import validationRules from "@/helpers/validationrules";

export default {
    components: {
        CropVarietyAttributes: CropVarietyAttributes,
        CropVarietyAttributeBulkEdit: CropVarietyAttributeBulkEdit,
        DeleteDialog: DeleteDialog,
        ConfirmDialog: ConfirmDialog,
        SuccessDialog: SuccessDialog
    },
    props: {
        crop: {
            required: true,
            type: Object
        },
        submitError: {
            required: false,
            type: String
        },
        submitLoading: {
            required: false,
            type: Boolean
        },
    },
    data() {
        return {
            selectedProductVarietyID: null,
            formValid: true,
            rules: validationRules.rules,
            selectedVarieties: [],
            selectedAttributes: [],
            deleteItem: null,
            showConfirmDelete: false,
            panels: null,
            showConfirmApply: false,
            cropVarietyTemplate: null,
            showCheckbox: false,
            builkEditButtonText:'BULK EDIT',
            selectAllButtonText: "SELECT ALL",
            showBulkEditCropVarietyAttribute:false,
            bulkEditSuccess:false,
            selectAll:false
        }
    },
    computed: {
        productVarieties() {
            return this.$store.getters["CropStore/getProductVarieties"](this.crop.ProductTypeID);
        },
        mandatoryAttributes() {
            return this.$store.getters["CropStore/getAttributes"](this.crop.ProductTypeID).filter(a => a.Mandatory);
        },
        disableAddVariety() {
            return this.selectedProductVarietyID == null || this.crop.CropVarieties.some(c => c.ProductVarietyID == this.selectedProductVarietyID);
        }
    },
    methods: {
        async next() {
            this.$emit('next');
        },
        showApplyAttributesToVarietySelector(cropVariety) {
            return this.crop.CropVarieties.length > 1 && cropVariety.Attributes.filter(a => a.AttributeMandatory).length > 0;
        },
        getOtherVarieties(cropVariety) {
            return this.productVarieties.filter(v => v.ProductVarietyID != cropVariety.ProductVarietyID && this.crop.CropVarieties.some(cv => cv.ProductVarietyID == v.ProductVarietyID));
        },
        showConfirmApplyDialog(cropVariety) {
            this.cropVarietyTemplate = cropVariety;
            this.showConfirmApply = true;
        },
        handleSelectAll(){
            this.selectAll = !this.selectAll;
            if(this.selectAll){
                this.selectAllButtonText = "UNSELECT ALL";
            }
            else{
                this.selectAllButtonText = "SELECT ALL";
            }
        },
        formatDate(v) {
            if (v) {
                return UtilService.formatDateDMY(v, '/');
            }

            return null;
        },
        formatDateYMD(v) {
            if(v) {
                return UtilService.formatDateYMD(v);
            } 
            return null;
        },
        updatePlantingDate(item, value) {
            this.$set(item, 'PlantingDate', value);
            this.calculateMinPlantingDate();
            item.plantingMenu = false;
        },
        clearPlantingDate(item) {
            item.plantingMenu = true;
            this.$set(item, 'PlantingDate', null);
            item.plantingMenu = false;
        },
        lookupVarietyName(productVarietyID) {
            let match = this.productVarieties.find(p => p.ProductVarietyID === productVarietyID);
            
            if (match) {
                return match.Name;
            }

            return 'Unknown';
        },
        addVariety() {
            let cropVariety = {
                CropID: this.crop.CropID,
                ProductVarietyID: this.selectedProductVarietyID,
                PlantingDate: this.crop.PlantingDate,
                Attributes: []
            };

            this.addMandatoryAttributes(cropVariety);
            this.crop.CropVarieties.push(cropVariety);

            this.selectedProductVarietyID = null;
            this.panels = this.crop.CropVarieties.length - 1;
        },
        handleDeleteVariety(item) {
            this.deleteItem = item;
            this.showConfirmDelete = true;
        },
        handleBulkEditAttributeCancel() {
            this.showBulkEditCropVarietyAttribute = false;
            this.builkEditButtonText == "BULK EDIT";
        },
        handleBulkEditAttributeSubmit(editData) {
            this.error = null;
            this.showBulkEditCropVarietyAttribute = false;
            if(this.selectedAttributes.length > 0){
                for(const attribute of this.selectedAttributes){
                    for(const cropVariety of this.crop.CropVarieties){
                        if(attribute.CropVarietyID==cropVariety.CropVarietyID){
                            for(const cropAttribute of cropVariety.Attributes ){
                                if(attribute.AttributeID == cropAttribute.AttributeID){
                                    for(const attributeValue of cropAttribute.Values){
                                       if(attribute.CropVarietyAttributeID==attributeValue.CropVarietyAttributeID){
                                           if(editData.StartDate != null){
                                               attributeValue.StartDate = editData.StartDate;
                                           }
                                           if(editData.EndDate != null){
                                               attributeValue.EndDate = editData.EndDate;
                                           }
                                           attributeValue.checked = false;
                                           this.selectAll = false;
                                           this.selectAllButtonText = "SELECT ALL";
                                       } 
                                    }
                                }
                            }
                        }
                    }
                }
            }
            this.showBulkEditCropVarietyAttribute = false;
            this.showCheckbox = false;
            this.builkEditButtonText = "BULK EDIT";
            this.selectedAttributes.splice(0,this.selectedAttributes.length);
            this.bulkEditSuccess = true;
        },
        confirmDelete() {
            const index = this.crop.CropVarieties.indexOf(this.deleteItem);
            this.crop.CropVarieties.splice(index, 1)
            this.showConfirmDelete = false;
        },
        showCheckBox(){
            if(this.builkEditButtonText == "BULK UPDATE" && this.selectedAttributes.length > 0){
                this.showBulkEditCropVarietyAttribute = true;
            }
            if(this.builkEditButtonText == "BULK UPDATE" && this.selectedAttributes.length == 0){
                this.showCheckbox = false;
                this.builkEditButtonText = "BULK EDIT";
                return;
            }
            this.showCheckbox = true;
            this.builkEditButtonText = "BULK UPDATE";
        },
        addMandatoryAttributes(cropVariety) {
            this.mandatoryAttributes.forEach(mandatory => {
                let match = cropVariety.Attributes.find(a => a.AttributeID === mandatory.AttributeID);
                
                if (!match) {
                    cropVariety.Attributes.push({
                        AttributeID: mandatory.AttributeID,
                        AttributeMandatory: mandatory.Mandatory,
                        AttributeName: mandatory.Name,
                        Values: []              
                    });
                }
            });
        },
        addSelectedAttributes(item){
            this.selectedAttributes.push(item);
        },
        removeSelectedAttributes(item){
            this.selectedAttributes = this.selectedAttributes.filter(attribute=>{
                return attribute.CropVarietyID != item.CropVarietyID || attribute.CropVarietyAttributeID != item.CropVarietyAttributeID || attribute.AttributeID != item.AttributeID;
            })   
        },
        calculateMinPlantingDate() {
            const variety = this.crop.CropVarieties.reduce((a,b)=>{
                return a.PlantingDate < b.PlantingDate ? a : b;
            })
            this.earliestPlatingDate = variety.PlantingDate;
            this.crop.PlantingDate = this.earliestPlatingDate;
        },
        hideSuccessDialog(){
            this.bulkEditSuccess = false;
        },
        confirmApply() {   
            // For each selected variety
            for (const cropVariety of this.crop.CropVarieties.filter(c => this.selectedVarieties.some(s => s == c.ProductVarietyID))) {
                
                cropVariety.PlantingDate = this.cropVarietyTemplate.PlantingDate;
                
                // Loop through all attributes and apply to selected varieties
                for (const attribute of this.cropVarietyTemplate.Attributes.filter(a => a.AttributeMandatory)) {               
                    // remove attribute if it exists
                    const index = cropVariety.Attributes.findIndex(a => a.AttributeID == attribute.AttributeID);

                    if (index > -1) {
                        cropVariety.Attributes.splice(index, 1);
                    }

                    // Copy Attribute and Values to variety;
                    let newAttribute = {
                        AttributeID: attribute.AttributeID,
                        AttributeName: attribute.AttributeName,
                        AttributeMandatory: attribute.AttributeMandatory,
                        CropVarietyID: cropVariety.CropVarietyID,
                        Values: attribute.Values.map(v => { 
                            return { 
                                AttributeID: v.AttributeID,
                                AttributeValueID: v.AttributeValueID,
                                StartDate: v.StartDate,
                                EndDate: v.EndDate,
                                UserDefinedValue: v.UserDefinedValue
                        }})                        
                    }

                    cropVariety.Attributes.push(newAttribute);
                }
            }

            this.showConfirmApply = false;
            this.cropVarietyTemplate = null;
            this.selectedVarieties = [];
        }
    },
    created() {        
        this.crop.CropVarieties.forEach(variety => {
            this.addMandatoryAttributes(variety);
        });
    }
}
</script>
